// extracted by mini-css-extract-plugin
export default {"table-container":"CategoryList_table-container__FCEHu","zr-table":"CategoryList_zr-table__zUj2o","table-header":"CategoryList_table-header__cI1Du"};